var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/swr.ts
import {
  node
} from "graph-state";
import {
  createSWRStore
} from "swr-store";

// src/utils.ts
function getKey(key) {
  return `/swr-graph-state/${key}`;
}
function ensure(value) {
  if (value == null) {
    throw new Error("Unable to return a nullish value.");
  }
  return value;
}

// src/swr.ts
function swr(options) {
  const _a = options, { key, setup } = _a, swrOptions = __objRest(_a, ["key", "setup"]);
  let fetcher;
  const store = createSWRStore(__spreadValues({
    key: () => getKey(key),
    get: () => fetcher()
  }, swrOptions));
  const resource = node({
    key: `SWR[${key}]`,
    get: (context) => {
      const newFetcher = setup(context);
      fetcher = newFetcher;
      context.subscription(() => store.subscribe([], (currentMutation) => {
        context.mutateSelf(currentMutation.result);
      }));
      return store.get([], {
        shouldRevalidate: true
      });
    }
  });
  return {
    subscribe: (listener) => store.subscribe([], (value) => {
      listener(value.result);
    }),
    trigger: (shouldRevalidate = true) => store.trigger([], shouldRevalidate),
    mutate: (data, shouldRevalidate = true) => store.mutate([], data, shouldRevalidate),
    resource
  };
}
function createSWRGraphNode(options) {
  return swr(options);
}

// src/swr-factory.ts
import {
  factory
} from "graph-state";
import {
  createSWRStore as createSWRStore2
} from "swr-store";
function swrFactory(options) {
  const _a = options, { key, setup } = _a, swrOptions = __objRest(_a, ["key", "setup"]);
  const fetcher = new Map();
  const store = createSWRStore2(__spreadValues({
    key: (...args) => getKey(key(...args)),
    get: (...args) => ensure(fetcher.get(key(...args)))()
  }, swrOptions));
  const resource = factory({
    factoryKey: options.factoryKey,
    key: (...args) => `SWR[${key(...args)}]`,
    get: (...args) => {
      const currentKey = key(...args);
      const currentSetup = setup(...args);
      return (context) => {
        const newFetcher = currentSetup(context);
        fetcher.set(currentKey, newFetcher);
        context.subscription(() => store.subscribe(args, (currentMutation) => {
          context.mutateSelf(currentMutation.result);
        }));
        return store.get(args, {
          shouldRevalidate: true
        });
      };
    }
  });
  return {
    subscribe: (args, listener) => store.subscribe(args, (value) => {
      listener(value.result);
    }),
    trigger: (args, shouldRevalidate = true) => store.trigger(args, shouldRevalidate),
    mutate: (args, data, shouldRevalidate = true) => store.mutate(args, data, shouldRevalidate),
    resource
  };
}
function createSWRGraphNodeFactory(options) {
  return swrFactory(options);
}

// src/global.ts
import {
  trigger as swrTrigger,
  mutate as swrMutate,
  subscribe as swrSubscribe
} from "swr-store";
function mutate(key, data, shouldRevalidate = true) {
  return swrMutate(getKey(key), data, shouldRevalidate);
}
function trigger(key, shouldRevalidate = true) {
  return swrTrigger(getKey(key), shouldRevalidate);
}
function subscribe(key, listener) {
  return swrSubscribe(key, (value) => {
    listener(value.result);
  });
}
export {
  createSWRGraphNode,
  createSWRGraphNodeFactory,
  mutate,
  subscribe,
  swr,
  swrFactory,
  trigger
};
/**
 * @license
 * MIT License
 *
 * Copyright (c) 2020 Alexis Munsayac
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 *
 * @author Alexis Munsayac <alexis.munsayac@gmail.com>
 * @copyright Alexis Munsayac 2020
 */
//# sourceMappingURL=index.js.map
